import { executeRequest, Request } from '@jfs/network'
import { createUserDeviceRequestBody } from '../data/request/requestbody'
import { APIEndPoints } from './APIEndpoints'
import { userDeviceConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const createUserDeviceReq = (
  tokens: any,
  appId: string,
  appType: string,
  deviceId: string,
  deviceToken: string,
  osName: number,
) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.createUserDevice,
    method: 'POST',
    config: userDeviceConfig(tokens),
    body: createUserDeviceRequestBody(appId, appType, deviceId, deviceToken, osName),
    headers: {
      'Content-Type': 'application/json',
      Authorization: tokens?.userAccessToken ?? '',
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { createUserDeviceReq }
